import { useState } from "react";
import { useEffect } from "react";

import { Box, useTheme } from "@mui/material";
import { v4 as uuid } from "uuid";

import SymptomScale from "../ui/symptomScale";

const QuestionSliderScaleDisplay = props => {
  const { question, onAnswerSelected } = props;

  const populateLocalAnswer = () => {
    if (question && question.answerValue && question.answerValue[0]) {
      return question.answerValue[0];
    } else {
      return 5;
    }
  };

  const [localAnswer, setLocalAnswer] = useState(populateLocalAnswer());

  const theme = useTheme();

  useEffect(() => {
    onAnswerSelected([localAnswer]);
  }, [localAnswer, onAnswerSelected]);

  useEffect(() => {
    if (question && question.answerValue && question.answerValue[0]) {
      setLocalAnswer(question.answerValue[0]);
    }
  }, [question, setLocalAnswer]);

  return (
    <Box sx={{ marginTop: theme.spacing(2), width: "100%" }}>
      <SymptomScale
        key={`answerOptionQuestion${question.omniID}`}
        name={uuid()}
        value={localAnswer}
        defaultValue={localAnswer}
        valueEditedHandler={e => setLocalAnswer(e)}
        defaultLabel={question.answerOptions[0].text}
      />
    </Box>
  );
};

export default QuestionSliderScaleDisplay;
